<template>
<div>
  <form @submit.prevent="submit">
    <b-row>

        <b-col sm="6">
            <label>Hora Inicio Carga</label>
            <datetime
              type="datetime"
              auto
              v-model="waybillDataTransportExport.start_time"
              required
              :minute-step="10"
              aria-describedby="input-inputFechaTermino-live-feedback"
              input-class="form-control"
              class="theme-orange">
            </datetime>
        </b-col>

         <b-col sm="6">
           <label>Hora Término Carga</label>
            <datetime
              type="datetime"
              auto
              v-model="waybillDataTransportExport.end_time"
              required
              :minute-step="10"
              aria-describedby="input-inputFechaTermino-live-feedback"
              input-class="form-control"
              class="theme-orange">
            </datetime>
        </b-col>
     
        <b-col sm="6">
            <b-form-group label="Nombre Chofer">
            <b-form-input
                type="text"
                v-model="waybillDataTransportExport.driver_name"
                placeholder="">
                </b-form-input>
                </b-form-group>

                <b-form-group label="Tel. Celular">
            <b-form-input
                type="text"
                v-model="waybillDataTransportExport.tel"
                placeholder="">
                </b-form-input>
                </b-form-group>
        </b-col>



        <b-col sm="6">
                <b-form-group label="Patente Camión">
            <b-form-input
                type="text"
                v-model="waybillDataTransportExport.truck_patent"
                placeholder="">
                </b-form-input>
                </b-form-group>

                <b-form-group label="Patente Carro">
            <b-form-input
                type="text"
                v-model="waybillDataTransportExport.patent_car"
                placeholder="">
                </b-form-input>
                </b-form-group>
        </b-col>

        <b-col sm="12">
            <b-form-group label="Cedula de identidad">
                    <b-form-input
                        type="text"
                        v-model="waybillDataTransportExport.identification_card"
                        placeholder="">
                    </b-form-input>
            </b-form-group>
        </b-col>

         <b-col sm="6">  
           <b-form-group label="Responsable">
                <b-form-textarea
                v-model="waybillDataTransportExport.responsible"
                    placeholder=""
                    rows="3"
                    max-rows="6">
                </b-form-textarea>
            </b-form-group>
      </b-col>



      <b-col sm="6">
          <b-form-group label="Observaciones">
                <b-form-textarea
                v-model="waybillDataTransportExport.observations"
                    placeholder=""
                    rows="3"
                    max-rows="6">
                </b-form-textarea>

            </b-form-group>
      </b-col>


      
    </b-row>
  </form>
  </div>
</template>

<script>



  export default {
    name: "formDataTransporte",
    props: [
      'waybill_id',
      'waybillDataTransportExport',
    ],
    data() {
      return {
      }
    },
    mounted () {
    },
    methods: {
      loadDataForm(){
          this.$axios.get('/api/comex/export_waybill/detailed_data_transport_export/', {
            params: {
              waybill_id: this.waybill_id
            }
          })
            .then(res => {
                    this.waybillDataTransportExport.driver_name= res.data.data[0].driver_name;
                    this.waybillDataTransportExport.tel= res.data.data[0].tel;
                    this.waybillDataTransportExport.identification_card= res.data.data[0].identification_card;
                    this.waybillDataTransportExport.truck_patent= res.data.data[0].truck_patent;
                    this.waybillDataTransportExport.patent_car= res.data.data[0].patent_car;
                    this.waybillDataTransportExport.observations= res.data.data[0].observations;
                    this.waybillDataTransportExport.responsible= res.data.data[0].responsible;

                    this.waybillDataTransportExport.start_time= res.data.data[0].start_time;
                    this.waybillDataTransportExport.end_time= res.data.data[0].end_time;
            }).catch(error => {
            });
      },
      submit() {
      },
    },
    beforeMount() {
      
    },
  }

</script>

<style scoped>

</style>
